import api from 'api'
import { DropdownItem } from 'bold-ui'
import { DropdownButton } from 'components/dropdown'
import { useHandleImpressao } from 'hooks/impressao/useHandleImpressao'
import { noop } from 'lodash'
import React from 'react'

interface AtendimentoInativoActionsProps {
  coUnicoAtendProf: string
  isRetificado: boolean
}

export function AtendimentoInativoActions(props: Readonly<AtendimentoInativoActionsProps>) {
  const { coUnicoAtendProf, isRetificado } = props
  const { handleImpressaoPath } = useHandleImpressao()

  const imprimir = (coUnicoAtendProf: string) =>
    handleImpressaoPath({
      apiPath: api.retificacaoAtendimento.imprimirAtendimentoInativo,
      values: { coUnicoAtendProf },
      file: `AtendimentoInativo_${coUnicoAtendProf}`,
    })

  return (
    <DropdownButton stopPropagationOnClick onKeyDown={(e) => e.stopPropagation()}>
      {/*TODO(RNG) #26114: Impressão dos registros inativos do atendimento retificado */}
      <DropdownItem onClick={isRetificado ? noop : () => imprimir(coUnicoAtendProf)}>
        Imprimir registro inativo
      </DropdownItem>
      {/*TODO(RNG) #24481: Auditoria */}
      <DropdownItem onClick={noop}>Imprimir auditoria do registro</DropdownItem>
    </DropdownButton>
  )
}
